package com.starparty.app.astro0.renderers

import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.SP_Paint
import com.starparty.app.astro0.celestialobjects.CelestialBody
import com.starparty.app.astro0.celestialobjects.DSO

class NightVisionRendererTheme(backgroundPaint: SP_Paint,
                              constellationsPaint: SP_Paint,
                              constellationTitlesPaint: SP_Paint,
                              constellationBoundaryPaint: SP_Paint,
                              celestialBodyPaint: SP_Paint,
                              darkPhasePaint: SP_Paint,
                              altAzmGridPaint: SP_Paint,
                              altAzmGridLabelsPaint: SP_Paint,
                              altAzmZeroGridPaint: SP_Paint,
                              equGridPaint: SP_Paint,
                              equGridLabelsPaint: SP_Paint,
                              equZeroGridPaint: SP_Paint,
                              equatorPaint: SP_Paint,
                              horizonPaint: SP_Paint,
                              centreMarkerPaint: SP_Paint):
    RendererTheme(
                backgroundPaint,
                constellationsPaint,
                constellationTitlesPaint,
                constellationBoundaryPaint,
                celestialBodyPaint,
                darkPhasePaint,
                altAzmGridPaint,
                altAzmGridLabelsPaint,
                altAzmZeroGridPaint,
                equGridPaint,
                equGridLabelsPaint,
                equZeroGridPaint,
                equatorPaint,
                horizonPaint,
                centreMarkerPaint) {

    private var nvCelestialBodyColour = SP_Colour(250,0,0,255)

    private val nvDSOColour = SP_Colour(255, 0, 0, 255)

    protected val nvDarkPhasePaintColor = SP_Colour(0,0,0,255)

    private var nvConstellationColor = SP_Colour(180, 0, 0,255)
    private val nvConstellationTitleColor = SP_Colour(180,0, 0, 255)
    private val nvConstellationBoundaryColor = SP_Colour(180,0, 0, 130)

    private var nvEquGridColor = SP_Colour(180, 0, 0, 255)
    private var nvEquZeroGridColor = SP_Colour(255, 0, 0, 255)
    private var nvAltAzmGridColor = SP_Colour(180, 0, 0, 255)
    private var nvAltAzmZeroGridColor = SP_Colour(255,0,0,250)
    private var nvEquatorColor = SP_Colour(255,0,0,255)
    private var nvHorizonColor = SP_Colour(255, 0,0, 255)
    private var nvAltAzmGridLabelColor = SP_Colour(255,0,0,255)

    private var nvEquGridLabelColour = SP_Colour(255, 0, 0, 255)

    private var nvCentreMarkerColour = SP_Colour(255, 0, 0, 255)

    init {
        constellationsPaint.setColour(nvConstellationColor)
        constellationTitlesPaint.setColour(nvConstellationTitleColor)
        constellationBoundaryPaint.setColour(nvConstellationBoundaryColor)

        darkPhasePaint.setColour(nvDarkPhasePaintColor)

        altAzmGridPaint.setColour(nvAltAzmGridColor)
        altAzmZeroGridPaint.setColour(nvAltAzmZeroGridColor)
        horizonPaint.setColour(nvHorizonColor)

        equGridPaint.setColour(nvEquGridColor)
        equZeroGridPaint.setColour(nvEquZeroGridColor)
        equatorPaint.setColour(nvEquatorColor)

        altAzmGridLabelsPaint.setColour(nvAltAzmGridLabelColor)
        equGridLabelsPaint.setColour(nvEquGridLabelColour)

        altAzmGridLabelsPaint.setTextSize(gridLabelTextSize)
        equGridLabelsPaint.setTextSize(gridLabelTextSize)

        centreMarkerPaint.setColour(nvCentreMarkerColour)
    }

    public override fun setDSOColour(dso: DSO) {
        celestialBodyPaint.setColour(nvDSOColour)
    }

    public override fun setCelestialBodyColour(cb: CelestialBody) {
        celestialBodyPaint.setColour(nvCelestialBodyColour)
    }
}